import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor(
            $state,
            Alert,
    		UsersResource,
    ) {
        this.$state = $state;
        this.Alert = Alert;
        this.UsersResource = UsersResource;
    }

    $onInit() {
        this.st = new SmartTable();

        var ctrl = this;
        this.displayed = [];
        this.callServer = function callServer(tableState) {
            ctrl.isLoading = true;
            var pagination = tableState.pagination;
            var page = pagination.start / pagination.number;
            var number = pagination.number;
            var searchText = (tableState.search.predicateObject ? tableState.search.predicateObject.searchText : '');
            var sort = tableState.sort.predicate;
            var sortReverse = tableState.sort.reverse;
            if (ctrl.page != page || ctrl.number != number || ctrl.searchText != searchText || ctrl.sort != sort || ctrl.sortReverse != sortReverse) {
                ctrl.page = page;
                ctrl.number = number;
                ctrl.searchText = searchText;
                ctrl.sort = sort;
                ctrl.sortReverse = sortReverse;
                ctrl.UsersResource
                    .getAllRegularCompanyUsersWithPagination(ctrl.companyId, "blocked", ctrl.page, ctrl.number, ctrl.searchText, ctrl.sort, ctrl.sortReverse)
                    .then(dto => {
                        pagination.totalItemCount = dto.totalElements;
                        pagination.numberOfPages = dto.totalPages;
                        ctrl.st.displayedItems = dto.content;
                })
                .finally(() => ctrl.isLoading = false);
            }
        }
    }
    
    unblock(account) {
        this.isUnblocking = true;
        this.UsersResource
            .unblockCompanyUser(this.companyId, account.id)
            .then(() => {
                this.Alert('success', 'company.user-directories.manage-user.unblocked');
                this.$state.go(this.$state.current, {} , {reload:true});
            })
            .finally(() => this.isUnblocking = false)

    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/blocked-users/blocked-users.controller.js